import { fetchDesignPage } from "../services/contentApi";
import { ServicePageProvider, useServicePage, useServiceSection } from "./ServicePageContext";

export function DesignPageProvider({ children }) {
  return (
    <ServicePageProvider fetchPage={fetchDesignPage}>{children}</ServicePageProvider>
  );
}

export const useDesignPage = useServicePage;
export const useDesignSection = useServiceSection;
